<template>
    <div>
      <Form @submit.native.prevent="preventSubmit" inline>
        <FormItem prop="dateTime" label="创建时间：" :label-width="90">
          <DatePicker type="daterange" v-model="dateTime" placeholder="选择日期" :clearable="false" class="date-time" style="width: 240px"></DatePicker>
        </FormItem>
        <FormItem prop="account" label="单据编号：" :label-width="90">
          <Input type="text" v-model="queryCriteria.orderNo"></Input>
        </FormItem>
        <FormItem prop="account" label="领用单号：" :label-width="90">
          <Input type="text" v-model="queryCriteria.invoiceId" style="width:200px;"></Input>
        </FormItem>
        <FormItem prop="account" label="领用人：" :label-width="90">
          <Input type="text" v-model="queryCriteria.userName"></Input>
        </FormItem>
        <FormItem prop="account" label="领用号码：" :label-width="90">
          <Input type="text" v-model="queryCriteria.account"></Input>
        </FormItem>
         <br>
        <FormItem prop="account" label="关联城市：" :label-width="100">
          <Input type="text" v-model="queryCriteria.associatedCityName"></Input>
        </FormItem>
        <FormItem prop="account" label="领用中心仓：" :label-width="100">
          <Input type="text" v-model="queryCriteria.repositoryName"></Input>
        </FormItem>
        <FormItem label="生成状态：" prop="createJxcOrderStatus" :label-width="90">
          <Select ref="register" v-model="queryCriteria.createJxcOrderStatus" filterable style="width:150px">
            <Option :value="0">全部</Option>
            <Option :value="1">成功</Option>
            <Option :value="2">失败</Option>
            <Option :value="3">申请中</Option>
          </Select>
        </FormItem>
        <FormItem label="审批状态：" prop="approvalStatus" :label-width="90">
          <Select ref="register" v-model="queryCriteria.approvalStatus" filterable style="width:150px">
            <Option :value="0">全部</Option>
            <Option :value="1">待审批</Option>
            <Option :value="2">审批通过</Option>
            <Option :value="3">已驳回</Option>
            <Option :value="4">已废弃</Option>
          </Select>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="queryAccountListWithKeyword">查询</Button>
        </FormItem>
      </Form>
      <!-- Table-->
      <Content>
        <Table stripe :loading="false" :columns="columns" :data="materialUseList"></Table>
        <div style="margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="listCount" :current="queryCriteria.page" :page-size="queryCriteria.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
      <!-- Modal 查看详情-->
      <Modal v-model="detailModal.display" :loading="true"  ref="detailModal" title="物品详情" width="500">
        <Form @submit.native.prevent="preventSubmit" :model="detailModal" :label-width="170">
          <Card dis-hover :padding='14' v-for="(item,key) in goodsTypeList" :key="key" v-if="item.materialsDetailses.length!==0">
            <p slot="title">{{item.typeName}}</p>
            <div class="card_span" v-for="(goods,key) in item.materialsDetailses" :key="key">
              <span style="border-right: 1px solid #fff;">{{`${goods.goodsName ? goods.goodsName : ''}`}}</span>
              <span>{{`${goods.goodsNum ? goods.goodsNum : 0}`}}</span>
            </div>
          </Card>
        </Form>
        <div slot="footer">
        </div>
      </Modal>
    </div>
</template>

<script>
import Moment from "moment";
import Utils from "../../../utils";
import API from "../../../api";

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.username = Utils.findFromLocalStorage("vue-username");
  },
  data() {
    return {
      // 表格数据
      materialUseList: [],
      // 物品详情
      goodsTypeList: [],
      //    分页
      listCount: 0,
      dateTime:[
        Moment().subtract(6, 'day').format('YYYY-MM-DD'),
        Moment().format('YYYY-MM-DD')
      ],
      //查询字段
      queryCriteria: {
        invoiceId: "",
        orderNo: "",
        userName: "",
        account: "",
        page: 1,
        pageSize: 10,
        repositoryName:'',
        beginDate:'',
        endDate:'',
        createJxcOrderStatus:0,
        approvalStatus:0,
        receiptsType:1,
        associatedCityName:''
      },
      queryParams: {
        invoiceId: "",
        orderNo: "",
        userName: "",
        account: "",
        page: 1,
        pageSize: 10,
        repositoryName:'',
        beginDate:'',
        endDate:'',
        createJxcOrderStatus:0,
        approvalStatus:0,
        receiptsType:1,
        associatedCityName:''
      },
      // 弹窗
      detailModal: {
        display: false
      },
      columns: [
        // {
        //   title: "领用id",
        //   key: "id",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "创建时间",
          key: "createDate",
          align: "center",
          width: 130,
          render:(h,p)=>{
          return h(
            'span',
              p.row.createDate ? Moment(p.row.createDate).format("YYYY-MM-DD HH:mm:ss") : ''
          )
         }
        },
        {
          title: "领用单号",
          key: "invoiceId",
          align: "center",
          width: 200,
        },
        {
          title: "单据编号",
          key: "orderNo",
          align: "center",
          width: 200,
        },
        {
          title: "领用人",
          key: "userName",
          align: "center",
          width: 100,
        },
        {
          title: "领用号码",
          key: "account",
          align: "center",
          width: 140,
        },
        {
          title: "预约领用时间",
          key: "appointmentDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.appointmentDate ? Moment(row.appointmentDate).format("YYYY-MM-DD HH:mm:ss") : '';
            return h("Span", {}, text);
          }
        },
        {
          title: "关联城市",
          key: "associatedCityName",
          align: "center",
          width: 140,
        },
        {
          title: "领用中心仓",
          key: "repositoryName",
          align: "center",
          width: 150,
        },
        {
          title: "领用物品",
          key: "useGoods",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.materialUseInfoModal(params.row.invoiceId);
                    }
                  }
                },
                "查看详情"
              )
            ]);
          }
        },
        {
          title: "生成状态",
          key: "createJxcOrderStatus",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h('Tag',{
                 props: {
                    color: "yellow",
                    size: "small"
                  },
              },params.row.createJxcOrderStatus == 1 ? '成功' : params.row.createJxcOrderStatus == 2 ? '失败':'申请中'),
              h('p',{},params.row.createJxcOrderStatus == 2 ? params.row.createOrderFailCause : '')
            ]);
          }
        },
        {
          title: "审批状态",
          key: "approvalStatus",
          align: "center",
          width: 100,
          render: (h, params) => {
            const statusText = ["", "待审批", "审批通过", "已驳回","已废弃"][
              params.row.approvalStatus
            ];
            return h("div", {}, statusText);
          }
        },
         {
          title: "出库时间",
          key: "outWarehouseDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.outWarehouseDate ? Moment(row.outWarehouseDate).format("YYYY-MM-DD HH:mm:ss"):'';
            return h("Span", {}, text);
          }
        },
        {
          title: "确认时间",
          key: "storageDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.storageDate ? Moment(row.storageDate).format("YYYY-MM-DD HH:mm:ss") : '';
            return h("Span", {}, text);
          }
        },
        {
          title: "领用状态",
          key: "recipientsState",
          align: "center",
          width: 100,
          render: (h, params) => {
            const statusList = ["", "待领用", "已领用","已失效"][
              params.row.recipientsState
            ];
            return h("div", {}, statusList);
          }
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                    disabled: params.row.recipientsState == 1 ? false : true
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "提示",
                        content:
                          "请仔细检查已领用的物品及数量，一经确定，将无法修改！",
                        okText: "确定",
                        cancelText: "取消",
                        onOk: () => {
                          this.confirmUseModal(params.row.id);
                        }
                      });
                    }
                  }
                },
                "确定领用"
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.queryAccountList();
    this.$Notice.config({
      top: 200
    });
  },
  methods: {
    // 页面列表数据
    async queryAccountList() {
      this.queryParams.beginDate = this.dateTime[0]
        ? Moment(this.dateTime[0]).format("YYYY-MM-DD")
        : "";
      this.queryParams.endDate = this.dateTime[1]
        ? Moment(this.dateTime[1]).format("YYYY-MM-DD")
        : "";
      this.queryParams.createJxcOrderStatus = this.queryCriteria.createJxcOrderStatus == 0 ? '' : this.queryCriteria.createJxcOrderStatus;
      this.queryParams.approvalStatus = this.queryCriteria.approvalStatus == 0 ? '' : this.queryCriteria.approvalStatus;
      let resp = (await API.omsAPI[this.env].cleaner.MmReceiptReturnList(
        this.queryParams,
        this.token
      )).data;
       if (resp.retCode) {
        this.$Notice.error({
          title: "获取列表失败",
          desc: resp.msg
        });
        return;
      }
      this.materialUseList = resp.list || [];
      this.listCount = resp.totalCount;
    },
    // 查询
    queryAccountListWithKeyword() {
      this.queryParams = Object.assign({}, this.queryCriteria);
      this.queryAccountList();
    },
    //物资领用详情
    async materialUseInfoModal(invoiceId) {
      let resp = (await API.omsAPI[this.env].cleaner.MmReceiptReturnGoods(
        { invoiceId: invoiceId },
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          desc: resp.msg
        });
      } else {
        this.goodsTypeList = resp || [];
        this.detailModal.display = true;
      }
    },
    // 确定领用
    async confirmUseModal(id) {
      const params = {
        id:id,
        updateName:this.username
      }
      let resp = (await API.omsAPI[this.env].cleaner.affirmReceive(
        params,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '领用失败',
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: '领用成功',
          desc: resp.msg
        });
      }
      this.queryAccountList();
    },
    // 分页
    changePageSize(pageSize) {
      this.queryParams.page = 1;
      this.queryParams.pageSize = pageSize;
      this.queryAccountList();
    },
    changePage(pageIndex) {
      this.queryParams.page = pageIndex;
      this.queryAccountList();
    },
    preventSubmit() {
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.card_span span {
  display: inline-block;
  width: 215px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #eee;
  border-bottom: 1px solid #fff;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/materialCollar-list/material-use.vue